export default "__VITE_ASSET__8Tjd1R59__"